import { render, staticRenderFns } from "./stage23.vue?vue&type=template&id=8fbdf068&scoped=true&"
import script from "./stage23.vue?vue&type=script&lang=js&"
export * from "./stage23.vue?vue&type=script&lang=js&"
import style0 from "./stage23.vue?vue&type=style&index=0&id=8fbdf068&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fbdf068",
  null
  
)

export default component.exports